import { ProductCenterRouteMap } from '@/new-router/product-center'

const Home = () => import('@/views/Home/home')

const OutsourcingManage = () => import('@/views/Outsourcing/OutsourcingManage/index')
const ProjectDetail = () => import('@/views/Outsourcing/OutsourcingManage/ProjectDetail/index')

const OutsourcingQualification = () => import('@/views/Outsourcing/OutsourcingQualification/index')
const QualificationDetail = () =>
  import('@/views/Outsourcing/OutsourcingQualification/QualificationDetail/index')
/**
 * hidden: true                   是否显示在侧栏上
 * meta : {
    title: 'title'               设置侧栏名字
    icon: 'svg-name'             侧栏icon图片名,
    showSubiems: ‘false’         侧栏的展开状态
    sort: 1,                     侧栏排序
    active: []                   业务逻辑的子页面高亮设置
    nocache: true                组件将不keep-alive
  }
 **/

export default [
  {
    path: '/outsourcing',
    name: 'outsourcing',
    component: Home,
    meta: {
      title: '外包管理',
      icon: 'icon-user',
      showSubiems: false,
      sort: 15,
      modules: 'outsourcing',
      permission: 'outsourcing:outsourcing',
    },
    children: [
      {
        path: 'project-manage',
        name: 'project-manage',
        component: OutsourcingManage,
        meta: {
          title: '项目管理',
          active: ['project-manage', 'project-detail'],
          permission: 'outsourcing:outsourcing:project',
          belong: [ProductCenterRouteMap.ProductCenter, ProductCenterRouteMap.Outsourcing],
        },
      },
      {
        path: 'detail/:id',
        name: 'project-detail',
        component: ProjectDetail,
        hidden: true,
        meta: {
          title: '项目详情',
          active: ['project-manage'],
          permission: 'outsourcing:outsourcing:project',
        },
      },
      {
        path: 'qualification',
        name: 'qualification',
        component: OutsourcingQualification,
        meta: {
          title: '资质申请',
          active: ['qualification', 'qualification-detail'],
          permission: 'outsourcing:outsourcing:qualification',
          belong: [ProductCenterRouteMap.ProductCenter, ProductCenterRouteMap.Outsourcing],
        },
      },
      {
        path: 'qualification-detail/:id',
        name: 'qualification-detail',
        component: QualificationDetail,
        hidden: true,
        meta: {
          title: '资质详情',
          active: ['qualification-detail'],
          permission: 'outsourcing:outsourcing:qualification',
        },
      },
    ],
  },
]
